import React, { useEffect } from 'react';
import classNames from 'classnames';

const EventTile = (props) => {
  const eventTileClasses = classNames({
    EventTile: true,
    'EventTile--react': true,
  });
  const eventImageStyles = {
    backgroundImage: `url(${props.image})`,
  };
  return (
    <div className={eventTileClasses} data-event-tile>
      <a className="EventTile__image" href={props.url} data-event-tile-image style={eventImageStyles}></a>
      <div className="EventTile__info">
        <p className="EventTile__date" data-event-tile-date>
          <a href={props.url}>{props.event_date}</a>
        </p>
        <h4 className="EventTile__title" data-event-tile-title>
          <a href={props.url}>{props.title}</a>
        </h4>
        {props.desktop && (
          <p className="EventTile__excerpt" data-event-tile-excerpt>
            <a href={props.url}>{props.excerpt}</a>
          </p>
        )}
        <p className="EventTile__url" data-event-tile-url>
          <a href={props.url}>View Details</a>
        </p>
      </div>
    </div>
  );
};

EventTile.defaultProps = {
  date: '',
  title: '',
  excerpt: '',
  image: '',
  url: '',
};

export default EventTile;
